import React, {useContext} from 'react'
import { Link } from 'react-router-dom'
import { LanguageContext } from '../../LanguageContext';

function Scholarship() {
    const { language, setLanguage } = useContext(LanguageContext);
  return (
    <>
        <section className="cta-area cta-bg pt-50 pb-50"  >
            <div className="container">
                <div className="row justify-content-center">
                <div className="col-lg-8">
                    <div className="section-title cta-title wow fadeInLeft animated" data-animation="fadeInDown animated" data-delay=".2s" >
                    <h2>{language === 'en' ? 'Scholarship Programs': 'छात्रवृत्ति कार्यक्रम'}</h2>
                    <p>{language === 'en' ? 'Various scholarships are available at IIT Tirupati for students who demonstrate merit. The Institute also provides financial help to students who qualify for it, in the form of selective scholarship amounts and fee waiver.'
                        : 'आईआईटी तिरुपति में योग्यता निरूपित करने वाले छात्रों के लिए विभिन्न छात्रवृत्तियाँ उपलब्ध हैं। संस्थान इसके लिए योग्यता प्राप्त छात्रों को चुनिंदा छात्रवृत्ति राशि और शुल्क छूट के रूप में वित्तीय सहायता भी प्रदान करता है।' }
                    </p>
                    </div>
                </div>
                <div className="col-lg-4 text-right">
                    <div className="cta-btn s-cta-btn wow fadeInRight animated mt-30" data-animation="fadeInDown animated" data-delay=".2s" >
                    <Link to="/institute-scholarships" className="btn ss-btn smoth-scroll">
                        {language ==='en' ? 'Financial Aid' : 'आर्थिक सहायता' }  <i className="fal fa-long-arrow-right" />
                    </Link>
                    </div>
                </div>
                </div>
            </div>
        </section>
    </>
  )
}

export default Scholarship